module.exports = __webpack_public_path__ + "img/emoji09.png";